import { SOGetUser } from '../user/so-get-user';


export class SOPostDatafeed {

  constructor(
    public name: string,
    public user: SOGetUser,
    public description: string = "",
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostDatafeed(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'user' in params ? params.user : null,
    );
  }
}
